import API from "@/api/";
import {
  SET_LIST,
  SET_DEPT,
  SET_TOTAL,
  SET_OFFSET,
  SET_MAX,
} from "./mutation-types";

export const list = ({ commit, state }, params = null) => {
  const newParams = params ?? {
    dept: state.dept,
    max: state.max,
    offset: state.offset,
    sort: state.sort,
    order: state.order,
  };
  //console.log(`action.groupMember.list: newParams = ${JSON.stringify(newParams)}`);
  return new Promise((resolve) => {
    API.groupDeptMember.list(newParams).then((res) => {
      const { max, offset, dept } = newParams;
      if (res.status === 200) {
        commit(SET_LIST, res.data[0]);
        commit(SET_TOTAL, res.data[1]);
        if (dept !== undefined) {
          commit(SET_DEPT, dept);
        }
        if (offset !== undefined) {
          commit(SET_OFFSET, offset);
        }
        if (max !== undefined) {
          commit(SET_MAX, max);
        }
        resolve(res);
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }
    });
  });
};
export const add = (_, params) => {
  delete params.adminUserName;
  delete params.adminName;
  delete params.checkPassword;
  return new Promise((resolve) => {
    API.groupDeptMember.add(params).then((res) => {
      if (res.status === 201) {
        resolve(res);
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }
    });
  });
};
export const get = (_, id) => {
  return new Promise((resolve) => {
    API.groupDeptMember.get(id).then((res) => {
      if (res.status === 200) {
        resolve(res);
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }
    });
  });
};
export const update = (_, params) => {
  delete params.adminUserName;
  delete params.adminName;
  delete params.checkPassword;
  if (!params.adminPassword) {
    delete params.adminPassword;
  }
  return new Promise((resolve) => {
    API.groupDeptMember.update(params).then((res) => {
      if (res.status === 200) {
        resolve(res);
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }
    });
  });
};
export const remove = (_, params) => {
  return new Promise((resolve) => {
    API.groupDeptMember.remove(params).then((res) => {
      if (res.status === 200) {
        resolve(res);
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }
    });
  });
};
export default {
  list,
  add,
  update,
  remove,
  get,
};
